import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ projects, resource, role }) =>
    present(
      repository
        .saveResourceInProjects(resource, projects, role)
        .then((projectResources) => ({
          projectResources,
          resource,
          projects,
          role,
        }))
        .catch(() => Promise.reject({ resource, projects, role })),
    );
}

export type { Interactor };

export { createInteractor };
